<template>
    <div>
        <div style="background:#eee">
            <a-spin tip="加载中..." 
            style="width:100%;text-align:center;margin-top:20px;margin-bottom:20px;" 
            :spinning="loading">
            </a-spin>
            <div class="main_report_edit_nav" :style="{'display':loading?'none':'block'}">
                <ul style="overflow:hidden;margin:0;padding:0;width:100%;">
                    <li style="height:60px;">
                        <span style="display:block;font-size:25px;margin:0;padding:0;height:50px;line-height:60px;text-align:center;">
                            {{ company.name }}
                        </span>
                    </li>
                </ul>
            </div>
            <div 
            class="main_report_edit_home" 
            style="border: 1px solid #ccc;margin-left:5px;margin-right:5px;border-radius:10px;background:#eee;" 
            :style="{'display':loading?'none':'block'}"
            >
                <div class="main_report_edit_top"  style="height:200px;border-radius:4px 4px 0px 0px;" :style="{backgroundImage: 'url(' + require('@/assets/edit_banner_background.png') + ')'}">
                    <div class="main_report_edit_header" style="margin:0;padding:0;margin-left:5px;margin-right:5px;height:320px;">
                        <span style="display:block;color:white;font-size:20px;padding-top:20px;text-align:center;">
                            检测单基本信息
                        </span>
                        <el-image
                        fit="cover"
                        style="background:#ddd;margin-top:50px;height:120%;display:block;width:100%;border-radius:10px;" 
                        :src="cover_urls && cover_urls.length > 0 && cover_urls[0] ? cover_urls[0] : ''"
                        :preview-src-list="cover_urls && cover_urls.length > 0 ? cover_urls : []"
                        >
                        </el-image>
                    </div>
                </div>
                <div class="main_report_edit_content" style="overfloat:hidden;margin-left:5px;margin-right:5px;background:white;border:1px solid #ccc;height:100%;margin-top:300px;border-radius:10px;">
                    <div class="base_info" style="margin-left:10px;margin-right:10px;height:60px;width:100%;">
                        <ul style="margin:0;padding:0;">
                            <li style="margin:0;padding:0;width:10px;height:30px;float:left;">
                                <div style="background:#155CF0;width:8px;height:20px;margin-top:21px;margin-right:0px;float:left;"></div>
                            </li>
                            <li style="margin:0;padding:0;float:left;">
                                <span style="display:block;width:200px;height:24px;line-height:24px;margin-top:19px;text-align:left;font-weight:bold;margin-left:6px;font-size:20px;">
                                    基本信息
                                </span>
                            </li>
                        </ul>
                    </div>
                    <ul style="margin:0;padding:0;">
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ order.auto.license_plate }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        车牌号:
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">

                            </div>
                        </li>
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ order.auto.model }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        车型:
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">

                            </div>
                        </li>
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ order.auto.displacement }} {{ order.auto.displacement_unit }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        排量:
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">

                            </div>
                        </li>
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ menu["gearbox_type"][order.auto.gearbox_type] }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        变速箱:
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">

                            </div>
                        </li>
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ order.auto.meter_mileage }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        表公里数:
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">

                            </div>
                        </li>
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ order.menu.name }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        检修类型:
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">

                            </div>
                        </li>
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ order.auto.vin_no }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        VIN(车架号):
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">

                            </div>
                        </li>
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ order.customer.name }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        联系人:
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">

                            </div>
                        </li>
                        <li style="margin:0;padding:0;height:60px;">
                            <ul style="margin:0;padding:0;">
                                <li style="margin:0;padding:0;float:right;margin-right:30px;">
                                    <span style="display:block;line-height:60px;color:black;font-size:18px;">
                                        {{ order.customer.idcard_no }}
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:30px;">
                                    <span style="display:block;line-height:60px;color:#999">
                                        身份证号:
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">
                            </div>
                        </li>
                    </ul>
                </div>
                <div style="background:white;margin-top:20px;">
                    <span style="color:#999;padding-top:20px;display:block;width:100%;margin-left:20px;margin-right:20px;height:60px;padding-top:30px;">
                        选择检修: <span style="color:red;font-weight:bold;">{{ order.menu.name }}</span> 绿色属于已检测，红色属于未检测
                    </span>
                    <ul style="overflow:hidden;margin:0;padding:0;margin-top:20px;background:white;padding-bottom:20px;">
                        <li style="float:left;width:30%;height:50px;margin-left:2.5%;margin-top:20px;">
                            <a @click="complete_order_info" :style="{'background':(info_is_complete)?'#1DC200':'#ff5a4f'}" style="display:block;width:100%;height:100%;background:#ff5a4f;border-radius:5px;line-height:50px;color:white;font-weight:bold;text-align:center;">
                                完善信息
                            </a>
                        </li>
                        <li v-for="(group, index) in order.groups" :key="index" @click="group_detail(group.identifier)" style="float:left;width:30%;height:50px;margin-left:2.5%;margin-top:20px;">
                            <a :style="{'background':(order.group_objects[index] && order.group_objects[index].detected)?'#1DC200':'#ff5a4f'}" style="display:block;width:100%;height:100%;border-radius:5px;line-height:50px;color:white;font-weight:bold;text-align:center;">
                                {{ group.name }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div style="height:180px;background:white;margin-top:20px;padding-top:20px;">
                    <span style="color:#999;text-align:left;display:block;margin-left:20px;">
                        检测结果及保养建议:
                    </span>
                    <a-textarea
                    :autoSize=false 
                    v-model="order.maintenance_recommendations"
                    placeholder="请输入检测结果及保养建议" 
                    style="margin-right:20px;margin-left:20px;padding:0;margin-top:20px;width:90%;min-height:80px;padding-top:6px;padding-left:10px;">

                    </a-textarea>
                </div>
                <div style="height:80px;background:white;">
                    <ul style="margin:0;padding:0;">
                        <li style="margin:0;padding:0;float:left;margin-left:20%;">
                            <a @click="commitOrder" :loading="commit_loading" style="display:block;color:white;border-radius:5px;background:#1890ff;width:100px;height:40px;line-height:40px;text-align:center;">
                                提交检修单
                            </a>
                        </li>
                        <li style="margin:0;padding:0;float:right;margin-right:20%;">
                            <a @click="reportIndex" style="display:block;color:#333;background:#F4F6E1;border-radius:5px;width:100px;height:40px;line-height:40px;text-align:center;">
                                预览检修单
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import order_model from '../../model/order'
import company_model from '../../model/company'
import request from '../../api/request'
import menu_model from '../../model/menu'
import watermark from 'watermark-dom'
import wx from 'weixin-js-sdk'

export default {
    name: 'ReportEdit',
    head: {
        title: "修改检测报告",
        meta:[
            { name: 'description', content: '修改检测报告'}
        ]
    },
    data: function() {
        return {
            order_id: "",
            order: order_model,
            menu: menu_model,
            
            loading: false,
            commit_loading: false,
            info_is_complete: false,
            company: company_model,
            cover_urls: [],
            share_cover_url: "",
        }
    },
    methods: {
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.initial_wexin_share()
            this.fetch_company()
            this.order_id = this.$route.query.order_id
            this.fetchOrder()
        },
        initial_wexin_share() {
            let js_sdk_params_resp = request.wechat.js_sdk_config(window.location.href)
            js_sdk_params_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        let js_sdk_params = response.data.data
                        console.log("js_sdk_params", js_sdk_params)
                        
                        // 配置微信JS-SDK
                        wx.config({
                            debug: false,
                            appId: js_sdk_params.appId,
                            timestamp: js_sdk_params.timestamp,
                            nonceStr: js_sdk_params.nonceStr,
                            signature: js_sdk_params.signature,
                            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
                        });
                        
                        // 使用箭头函数保持this指向
                        wx.ready(() => {
                            console.log('微信JS-SDK配置成功')
                            this.updatePageMeta()
                            this.setWeChatShare()
                        })
                        
                        // 添加错误处理
                        wx.error((res) => {
                            console.error('微信JS-SDK配置失败:', res)
                        })
                        
                    }
                } else {
                    console.error('获取微信配置失败:', response.data)
                }
            }).catch((error) => {
                console.error('微信SDK初始化请求失败:', error)
            })
        },
        // 微信分享相关方法
        updatePageMeta() {
            // 动态更新页面标题
            if (this.order.auto && this.order.auto.model) {
                document.title = `${this.order.auto.model}-${this.order.auto.license_plate} - 车质宝检测报告`
            }
            
            // 更新meta标签
            this.updateMetaTag('og:title', `${this.order.auto.model || '车辆'}-${this.order.auto.license_plate || ''} - 车质宝检测报告`)
            this.updateMetaTag('og:description', `${this.order.auto.model || '车辆'}-${this.order.auto.license_plate || ''}`)
            this.updateMetaTag('og:url', window.location.href)
            this.updateMetaTag('twitter:title', `${this.order.auto.model || '车辆'}-${this.order.auto.license_plate || ''} - 车质宝检测报告`)
            this.updateMetaTag('twitter:description', `${this.order.auto.model || '车辆'}-${this.order.auto.license_plate}`)
        },
        updateMetaTag(property, content) {
            let meta = document.querySelector(`meta[property="${property}"]`)
            if (!meta) {
                meta = document.createElement('meta')
                meta.setAttribute('property', property)
                document.head.appendChild(meta)
            }
            meta.setAttribute('content', content)
        },
        
        setWeChatShare() {
            // 检查微信SDK是否已准备就绪
            if (typeof wx === 'undefined') {
                console.warn('微信JS-SDK未加载')
                return
            }
            
            const shareTitle = `${this.order.auto.model || '车辆'}-${this.order.auto.license_plate} - 车质宝检测报告`
            const shareDesc = `${this.order.auto.model || '车辆'}-${this.order.auto.license_plate}`
            const shareLink = window.location.href
            const shareImgUrl = this.share_cover_url
            
            console.log('设置微信分享内容:', {
                title: shareTitle,
                desc: shareDesc,
                link: shareLink,
                imgUrl: shareImgUrl
            })
            
            // 分享给朋友
            wx.updateAppMessageShareData({
                title: shareTitle,
                desc: shareDesc,
                link: shareLink,
                imgUrl: shareImgUrl,
                success: function () {
                    console.log('分享给朋友设置成功')
                },
                fail: function (res) {
                    console.error('分享给朋友设置失败:', res)
                }
            })
            
            // 分享到朋友圈
            wx.updateTimelineShareData({
                title: shareTitle,
                link: shareLink,
                imgUrl: shareImgUrl,
                success: function () {
                    console.log('分享到朋友圈设置成功')
                },
                fail: function (res) {
                    console.error('分享到朋友圈设置失败:', res)
                }
            })
        },
        complete_order_info() {
            if (this.order && this.order.identifier) {
                this.$router.push({
                    name: 'OrderComplete',
                    query: {
                        order_id:this.order.identifier,
                    }
                });
            }
        },
        group_detail(group_identifier) {
            if (this.order && this.order.identifier && group_identifier) {
                this.$router.push({
                    name: 'Detect',
                    query: {
                        order_id: this.order.identifier,
                        group_id: group_identifier, 
                    }
                });
            }
            
        },
        fetchOrder() {
            this.loading = true
            var report_edit_resp = request.order.fetch_report_edit(this.order_id)
            report_edit_resp.then((response) => {
                this.loading = false
                var failed_message = "获取订单信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.order = response.data.data
                        var auto = this.order.auto
                        if (auto) {
                            this.info_is_complete = auto.license_plate && auto.model && auto.vin_no && auto.meter_mileage && auto.vehicle_color && auto.displacement >= 0
                        }
                        if (this.order.auto.covers) {
                            var cache_cover_urls = []
                            for (var cover of this.order.auto.covers) {
                                if (cover.image_url) {
                                    cache_cover_urls.push(cover.image_url)
                                }
                            }
                            this.cover_urls = cache_cover_urls
                            this.share_cover_url = cache_cover_urls.length > 0 ? cache_cover_urls[0] : ""
                            console.log('封面图片加载完成:', this.share_cover_url)
                            this.$forceUpdate();
                        }

                        // 确保数据加载完成后再更新分享内容
                        this.$nextTick(() => {
                            this.updatePageMeta()
                            this.setWeChatShare()
                        })
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
            
        },
        reportIndex() {
            this.$router.push({
                name: 'ReportExport',
                query: {
                    order_id:this.order_id,
                }
            });
        },
        commitOrder() {
            this.commit_loading = true
            var order_commit_resp = request.order.commit(this.order_id, this.order.maintenance_recommendations)
            order_commit_resp.then((response) => {
                this.commit_loading = false
                var failed_message = "提交订单失败"
                var success_message = "提交订单成功"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.message) {
                        success_message = response.data.message
                    }
                    this.$message.success(success_message)
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    if (failed_message.length < 50) {
                        this.$message.error(failed_message)    
                    }
                    else {
                        this.$error({
                            title: '错误信息',
                            content: failed_message,
                        });
                    }
                }
            })
            .catch((error) => {
                this.commit_loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        }
    },
    created() {
        this.load()
    },
    components: {

    }
}
</script>

<style>


</style>
